import React, { HTMLAttributes } from 'react';
interface IconProps extends HTMLAttributes<SVGElement> {
	width?: number;
	height?: number;
}
export const NoDataSubscribeIcon = ({
	width = 200,
	height = 200,
	...restProps
}: IconProps) => {
	return (
		<svg
		{...restProps}
		width={width}
			height={height}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
    }}
    viewBox="0 0 2800 1616"
  >
    <path
      d="M2796.42 1437.86c-315.91 108.437-797.698 177.766-1337.06 177.766-539.359 0-1021.15-69.329-1337.06-177.766 315.91-80.513 797.698-131.99 1337.06-131.99 539.359 0 1021.15 51.477 1337.06 131.99Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M449.932 134.476c22.253-15.327 49.21-24.303 78.248-24.303 76.265 0 138.182 61.917 138.182 138.181H.291A240.41 240.41 0 0 1 0 236.526C0 105.984 105.984 0 236.526 0c94.007 0 175.278 54.961 213.406 134.476Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M2265.28 207.626c-19.683-13.557-43.528-21.497-69.213-21.497-67.457 0-122.224 54.767-122.224 122.224h589.153c.171-3.466.257-6.954.257-10.462 0-115.467-93.744-209.212-209.211-209.212-83.152 0-155.038 48.615-188.762 118.947Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M2508.45 917.725c-14.385-9.908-31.811-15.71-50.582-15.71-49.3 0-89.325 40.025-89.325 89.324h430.569c.125-2.533.188-5.082.188-7.646 0-84.386-68.511-152.897-152.898-152.897-60.769 0-113.305 35.528-137.952 86.929Z"
      style={{
        fill: "url(#d)",
      }}
    />
    <path
      d="M1514.65 490.223c98.031-181.271 294.095-181.271 392.128-90.636 98.035 90.636 98.035 271.908 0 453.179-68.623 135.954-245.08 271.908-392.128 362.544-147.049-90.636-323.505-226.59-392.128-362.544-98.032-181.271-98.032-362.543 0-453.179 98.032-90.635 294.096-90.635 392.128 90.636Z"
      style={{
        fill: "#bdc5cf",
      }}
    />
    <circle
      cx={1514.65}
      cy={816.917}
      r={159.654}
      style={{
        fill: "#d9dee4",
      }}
    />
    <path
      d="m1442.03 796.17 46.327 57.936 98.916-74.378"
      style={{
        fill: "none",
        stroke: "#f4f4f4",
        strokeWidth: "32.85px",
      }}
    />
    <path
      d="M783.555 606.278v-29.531s-14.438-15.592-17.509-34.728c0 0-16.085-19.109-9.261-27.641 3.591-4.489 8.316 1.89 8.316 1.89s-3.356-28.822-11.01-42.288c-7.654-13.466-9.78-21.735-9.78-21.735s60.006-59.298 120.486-.236c0 0 12.349 1.568 10.394 13.938-3.209 20.316-16.064 56.227-16.064 56.227s3.461-8.064 8.493-10.29c5.032-2.225 10.801 6.168 5.091 16.619-5.709 10.451-13.046 14.335-13.046 14.335s-4.956 18.925-17.241 35.226l-.236 35.2-31.185 22.68-27.448-29.666Z"
      style={{
        fill: "#f9b6b1",
      }}
    />
    <clipPath id="e">
      <path d="M783.555 606.278v-29.531s-14.438-15.592-17.509-34.728c0 0-16.085-19.109-9.261-27.641 3.591-4.489 8.316 1.89 8.316 1.89s-3.356-28.822-11.01-42.288c-7.654-13.466-9.78-21.735-9.78-21.735s60.006-59.298 120.486-.236c0 0 12.349 1.568 10.394 13.938-3.209 20.316-16.064 56.227-16.064 56.227s3.461-8.064 8.493-10.29c5.032-2.225 10.801 6.168 5.091 16.619-5.709 10.451-13.046 14.335-13.046 14.335s-4.956 18.925-17.241 35.226l-.236 35.2-31.185 22.68-27.448-29.666Z" />
    </clipPath>
    <g clipPath="url(#e)">
      <path
        d="M767.539 518.082s-3.363-30.617 5.217-37.988c8.58-7.371 19.352-1.89 24.266 4.158 4.914 6.048 29.295-2.646 37.422-6.804 8.127-4.158 24.191-3.402 23.624 13.797-.567 17.198 0 30.617 0 30.617s21.444-26.624 23.752-55.232c2.307-28.608-81.313-75.91-114.074-70.834-32.761 5.075-35.99 77.518-35.99 77.518l35.783 44.768Z"
        style={{
          fill: "#332e30",
        }}
      />
      <path
        d="M849.97 571.179s-20.224 32.76-59.348 10.136c0 0 18.698 19.523 23.653 20.761 4.954 1.239 32.19-1.128 32.19-1.128l3.505-29.769Z"
        style={{
          fill: "#f08788",
        }}
      />
    </g>
    <path
      d="m743.623 1527.18 3.928 52.856 36.428 6.072-5.357-69.642-34.999 10.714ZM856.626 1529.22l.457 50.285 16.457 7.771 12.8-12.114 1.371-50.513-31.085 4.571Z"
      style={{
        fill: "#f9b6b1",
      }}
    />
    <path
      d="M699.631 964.702s-19.294 328.315-15.806 337.906c3.487 9.591 49.225 236.22 49.225 236.22l59.374 1.339s-19.68-187.84-24.144-246.991l40.178-225.443s16.348 176.005 20.533 228.32c4.185 52.315 11.858 242.742 11.858 242.742l62.081-1.395s9.068-195.309 10.463-270.643c1.395-75.334 4.185-285.291 4.185-311.797 0-26.506-217.947 9.742-217.947 9.742Z"
      style={{
        fill: "#062249",
      }}
    />
    <path
      d="M1184.79 756.134s13.019-9.948 16.969-19.456c3.949-9.508 19.602-16.676 19.602-16.676s9.069-8.631 15.506-16.823c6.436-8.192 4.388 4.827.877 11.995-3.511 7.168 1.463 8.924 1.463 8.924s20.919-15.945 27.209-24.137c6.29-8.192 10.825 20.918 3.949 36.424-6.875 15.506-41.251 29.257-53.247 32.914-11.995 3.657-29.549 12.727-29.549 12.727l-2.779-25.892ZM439.715 756.585s-13.019-9.947-16.969-19.455c-3.95-9.509-19.602-16.677-19.602-16.677s-9.069-8.63-15.506-16.822c-6.436-8.192-4.388 4.827-.878 11.995 3.511 7.168-1.462 8.923-1.462 8.923s-20.919-15.944-27.209-24.136c-6.29-8.192-10.825 20.918-3.95 36.424 6.876 15.506 41.252 29.257 53.247 32.914 11.995 3.657 29.549 12.726 29.549 12.726l2.78-25.892Z"
      style={{
        fill: "#f9b6b1",
      }}
    />
    <path
      d="m784.431 599.541-15.067 16.071s-60.267 10.714-67.633 16.071c-7.366 5.357-110.125 141.913-110.125 141.913L426.29 738.022 407.875 789.5s177.906 51.018 189.172 51.897c19.228 1.5 111.745-103.375 111.745-103.375l-16.471 243.694s158.375 16.678 231.031-.398l-6.495-233.334s82.826 104.54 101.969 108.842c29.799 6.696 200.22-68.972 200.22-68.972l-20.748-50.582s-130.525 51.624-140.57 49.28c-10.044-2.344-127.9-159.372-127.9-159.372l-73.183-12.707-12.053-15s-11.128 18.807-23.127 22.664c-12 3.857-29.926-5.979-37.034-22.596Z"
      style={{
        fill: "#7f58ff",
      }}
    />
    <path
      d="M668.675 1614.45h119.769s2.515-36.571-2.742-45.256c-5.257-8.686-10.057-4.114-10.057-4.114s1.828 10.057-8.686 10.514c-10.514.457-18.514-5.029-18.514-14.629 0-9.599-5.257-2.742-13.028 4.8-7.771 7.543-30.171 21.028-30.171 21.028s-44.571-2.057-36.571 27.657Z"
      style={{
        fill: "#efeef3",
      }}
    />
    <clipPath id="f">
      <path d="M668.675 1614.45h119.769s2.515-36.571-2.742-45.256c-5.257-8.686-10.057-4.114-10.057-4.114s1.828 10.057-8.686 10.514c-10.514.457-18.514-5.029-18.514-14.629 0-9.599-5.257-2.742-13.028 4.8-7.771 7.543-30.171 21.028-30.171 21.028s-44.571-2.057-36.571 27.657Z" />
    </clipPath>
    <g clipPath="url(#f)">
      <path
        d="M665.466 1607.98h134.032v15.543H668.209l-2.743-15.543Z"
        style={{
          fill: "#062249",
        }}
      />
    </g>
    <path
      d="M855.439 1568.23s-8.484 9.069-11.41 17.846-1.609 29.549-1.609 29.549h59.391s-.147-19.163-.293-25.599c-.146-6.437-14.628-24.429-14.628-24.429s-10.825 19.894-31.451 2.633Z"
      style={{
        fill: "#efeef3",
      }}
    />
    <clipPath id="g">
      <path d="M855.439 1568.23s-8.484 9.069-11.41 17.846-1.609 29.549-1.609 29.549h59.391s-.147-19.163-.293-25.599c-.146-6.437-14.628-24.429-14.628-24.429s-10.825 19.894-31.451 2.633Z" />
    </clipPath>
    <g clipPath="url(#g)">
      <path
        d="M798.321 1607.98h134.032v15.543H801.064l-2.743-15.543Z"
        style={{
          fill: "#062249",
        }}
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(89.48 200.05 1257.038) scale(456.65383)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="b"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="rotate(88.826 308.888 -47.733) scale(604.0588)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="c"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="scale(-534.302 534.302) rotate(88.826 -2.066 -2.54)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        id="d"
        x1={0}
        x2={1}
        y1={0}
        y2={0}
        gradientTransform="matrix(-8.00038 390.4 390.4 8.00038 2634.57 600.939)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#bdc5cf",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
    </defs>
  </svg>)};
